export default __webpack_public_path__ + "locales/lo-LA/DeleteThirdPartyDialog.json?hash=fca8fbaa2025f2b4e8f542141d0a26c9";